<template>
  <div id="app">
    <component v-bind:is="layout"></component>
    <!-- <AppLayout /> -->
  </div>
</template>

<script>
import Dashboard from "@/layouts/Dashboard";
import Auth from "@/layouts/Auth";
import { $users } from "@core/services/";

export default {
  components: {
    Dashboard: Dashboard,
    Auth: Auth,
    // AppLayout,
  },
  computed: {
    layout() {
      return this.$store.getters["ui/layout"];
    }
  },
  async mounted() {
    if (this.$keycloak && this.$keycloak.authenticated){
      this.$store.dispatch("auth/getRoles")
      this.$store.dispatch("auth/getPreferences")
      this.$store.commit("auth/loggedIn", true)
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/global.scss";
@import "@core/assets/styles/common.scss";
</style>